import {
  useAPIGetListPerencanaanPS,
  usePerencanaanPSListSummary,
} from 'api/kinerja/tim-penilai-ps/perencanaan'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

import type { PerencanaanFilterState } from 'types/kinerja-tim-penilai-ps'

export default function usePerencanaanList({
  filter,
  isEnabled = true,
}: {
  filter: PerencanaanFilterState
  isEnabled?: boolean
}) {
  const {
    isPPKPengawasSekolah,
    isTimKinerjaPengawasSekolah,
    isProfilePSPegawaiFetched,
  } = useRoleContext()

  const {
    data: summary,
    isLoading: isSummaryLoading,
    isFetched: isSummaryFetched,
  } = usePerencanaanPSListSummary({
    opts: {
      enabled:
        isProfilePSPegawaiFetched &&
        (isPPKPengawasSekolah || isTimKinerjaPengawasSekolah),
    },
  })

  const {
    data,
    isLoading: isListLoading,
    isFetched: isListFetched,
  } = useAPIGetListPerencanaanPS({
    filter,
    opts: {
      enabled:
        isEnabled &&
        isProfilePSPegawaiFetched &&
        (isPPKPengawasSekolah || isTimKinerjaPengawasSekolah),
    },
  })

  return {
    data,
    summary,
    isLoading: isListLoading || isSummaryLoading,
    isFetched: isListFetched && isSummaryFetched,
  }
}
